import useMedia from '@hooks/use-media';
import type { FC } from 'react';

import { DESKTOP_MINIMUM_WIDTH } from './consts';
import styles from './OnboardingFlowContainers.module.scss';

type OnboardingFlowContainerProps = {
  isDisplaying?: boolean;
};

const OnboardingFlowContainerForMobile: FC<React.PropsWithChildren<OnboardingFlowContainerProps>> = ({
  children,
  isDisplaying = true,
}) => {
  const screenSizeCategory = useMedia<'small' | 'large'>(
    [`(min-width: ${DESKTOP_MINIMUM_WIDTH}px)`],
    ['large'],
    'small',
  );

  return (
    <div data-is-displaying={isDisplaying} className={styles['mobile-onboarding-flow-container']}>
      {screenSizeCategory === 'small' ? children : null}
    </div>
  );
};

const OnboardingFlowContainerForDesktop: FC<React.PropsWithChildren<OnboardingFlowContainerProps>> = ({
  children,
  isDisplaying = true,
}) => {
  const screenSizeCategory = useMedia<'small' | 'large'>(
    [`(min-width: ${DESKTOP_MINIMUM_WIDTH}px)`],
    ['large'],
    'small',
  );

  return (
    <div data-is-displaying={isDisplaying} className={styles['desktop-onboarding-flow-container']}>
      {screenSizeCategory === 'large' ? children : null}
    </div>
  );
};

export { OnboardingFlowContainerForMobile, OnboardingFlowContainerForDesktop };
